import(/* webpackMode: "eager", webpackExports: ["AdServerBannerContent"] */ "/root/project/app/domain/ad-server/components/AdServerBanner/AdServerBannerContent.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/ad-server/components/AdServerConfigurationContextProvider/AdServerConfigurationContextProvider.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/ad-server/components/AdServerConfigurationContextProvider/useAdServerConfigurationContext.ts");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/ad-server/components/AdServerExperimentActivation/AdServerExperimentActivation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useRecommendationPreloadedSlotsPush"] */ "/root/project/app/domain/ad-server/useCrossSellPreloadedSlotsPush.ts");
;
import(/* webpackMode: "eager", webpackExports: ["AlgoliaLandingPageSearchProvider","useAlgoliaLandingPageSearchContext"] */ "/root/project/app/domain/algolia/components/AlgoliaLandingPageSearchProvider.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/algolia/components/AlgoliaUserTokenProvider/AlgoliaUserTokenContext.ts");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/algolia/context/algoliaConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BaseHookFormErrorMessage"] */ "/root/project/app/domain/base-form-handling/BaseHookFormErrorMessage/BaseHookFormErrorMessage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useRunResetOnSubmitSuccessfull"] */ "/root/project/app/domain/base-form-handling/hooks/hooks/useRunResetOnSubmitSuccessfull.ts");
;
import(/* webpackMode: "eager", webpackExports: ["RadioInputGroupHookFormController"] */ "/root/project/app/domain/base-form-handling/RadioInput/RadioInputGroupHookFormController.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/cdn/components/CdnProvider/CdnContext.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useCdnMediaServer"] */ "/root/project/app/domain/cdn/useCdnMediaServer.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ContactPage"] */ "/root/project/app/domain/contact-page/components/ContactPage.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/device-detector/context/deviceDetectorContext.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/expa/components/ExpaProvider/ExpaContextProvider.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/feature-toggles/FeatureToggleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalConfigContextProvider","useGlobalConfigContext"] */ "/root/project/app/domain/global-config/context/globalConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GtmProvider"] */ "/root/project/app/domain/gtm/components/GtmProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["gtmApiUrlFetcher"] */ "/root/project/app/domain/gtm/usePushGtmDataPropsToGtmDataLayer.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/i18n/components/I18nProvider/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextImageWithFallback"] */ "/root/project/app/domain/image/NextImageWithFallback/NextImageWithFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Picture"] */ "/root/project/app/domain/image/Picture/Picture.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/next-pathname/nextPathnameContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoGlobalConfigProvider","useSeoGlobalConfigContext"] */ "/root/project/app/domain/seo/components/context/seoGlobalConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoAppMetaAndLinkTags"] */ "/root/project/app/domain/seo/components/SeoAppMetaAndLinkTags.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/seo/components/SeoBreadcrumbListJsonLd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SeoGlobalJsonLd"] */ "/root/project/app/domain/seo/components/SeoGlobalJsonLd.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/social-media/facebook.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/social-media/instagram.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/social-media/mail.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/social-media/pinterest.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/social-media/twitter.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/social-media/whatsapp.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/social-media/youtube.svg");
;
import(/* webpackMode: "eager", webpackExports: ["StandardShopLayout"] */ "/root/project/app/domain/standard-shop-layout/components/StandardShopLayout/StandardShopLayout.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/standard-shop-layout/footer/components/Footer/FooterTrusted/FooterTrustedItem.module.css");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/standard-shop-layout/footer/images/dimdi-at.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/standard-shop-layout/footer/images/dimdi-it.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/standard-shop-layout/footer/images/dimdi.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/standard-shop-layout/footer/images/e-prescription.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/standard-shop-layout/footer/images/vet-at.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/standard-shop-layout/footer/images/vet-it.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/standard-shop-layout/footer/images/vet.png");
;
import(/* webpackMode: "eager", webpackExports: ["useStickyBannerContext"] */ "/root/project/app/domain/standard-shop-layout/stickyBanner/StickyBannerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useApiSwrGetCustomerData"] */ "/root/project/app/domain/user-data/api/swr/useApiSwrGetCustomerData.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useApiSwrReavailabilityNotificationGetSubscriptionStatus"] */ "/root/project/app/domain/user-data/api/swr/useApiSwrReavailabilityNotificationGetSubscriptionStatus.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useApiSwrReavailabilityNotificationSubscribeUpidMutation"] */ "/root/project/app/domain/user-data/api/swr/useApiSwrReavailabilityNotificationSubscribeUpidMutation.ts");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/user-data/api/swr/useUserApiSwrGetMiniCart.ts");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/user-data/api/swr/useUserApiSwrSessionV1Customer.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useGtmPushLogoutOnSessionEnd"] */ "/root/project/app/domain/user-data/useGtmPushLogoutOnSessionEnd.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useRunCallbackWhenSessionCallIsDone"] */ "/root/project/app/domain/user-data/useRunCallbackWhenSessionCallIsDone.ts");
;
import(/* webpackMode: "eager" */ "/root/project/app/domain/webview/webviewContext.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/images/illustrations/illustration-free-delivery-s-clear.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/images/illustrations/illustration-own-brands-s-clear.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/images/illustrations/illustration-product-range-s-clear.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/images/illustrations/illustration-standard-delivery-clear-s.png");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/logos/logo-BE-desktop.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/logos/logo-BE-mobile.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/logos/logo-CH-desktop.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/logos/logo-CH-mobile.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/logos/logo-COM-rebranding.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/logos/logo-FR-desktop.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/logos/logo-FR-mobile.svg");
;
import(/* webpackMode: "eager" */ "/root/project/app/public/logos/logo-IT-rebranding.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/root/project/node_modules/@mui/base/Button/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["FormControl"] */ "/root/project/node_modules/@mui/base/FormControl/FormControl.js");
;
import(/* webpackMode: "eager", webpackExports: ["useFormControlContext"] */ "/root/project/node_modules/@mui/base/FormControl/useFormControlContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["Input"] */ "/root/project/node_modules/@mui/base/Input/Input.js");
;
import(/* webpackMode: "eager", webpackExports: ["Modal"] */ "/root/project/node_modules/@mui/base/Modal/Modal.js");
;
import(/* webpackMode: "eager", webpackExports: ["Option"] */ "/root/project/node_modules/@mui/base/Option/Option.js");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/root/project/node_modules/@mui/base/Select/Select.js");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/root/project/node_modules/@mui/base/Slider/Slider.js");
;
import(/* webpackMode: "eager", webpackExports: ["Switch"] */ "/root/project/node_modules/@mui/base/Switch/Switch.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tab"] */ "/root/project/node_modules/@mui/base/Tab/Tab.js");
;
import(/* webpackMode: "eager", webpackExports: ["TabPanel"] */ "/root/project/node_modules/@mui/base/TabPanel/TabPanel.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "/root/project/node_modules/@mui/base/Tabs/Tabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["TabsList"] */ "/root/project/node_modules/@mui/base/TabsList/TabsList.js");
;
import(/* webpackMode: "eager", webpackExports: ["useList"] */ "/root/project/node_modules/@mui/base/useList/useList.js");
;
import(/* webpackMode: "eager", webpackExports: ["useListItem"] */ "/root/project/node_modules/@mui/base/useList/useListItem.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSwitch"] */ "/root/project/node_modules/@mui/base/useSwitch/useSwitch.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClassNameConfigurator"] */ "/root/project/node_modules/@mui/base/utils/ClassNameConfigurator.js");
;
import(/* webpackMode: "eager", webpackExports: ["useRootElementName"] */ "/root/project/node_modules/@mui/base/utils/useRootElementName.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSlotProps"] */ "/root/project/node_modules/@mui/base/utils/useSlotProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/useControlled/useControlled.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/useEventCallback/useEventCallback.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/useForkRef/useForkRef.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/useId/useId.js");
;
import(/* webpackMode: "eager" */ "/root/project/node_modules/@mui/utils/esm/useIsFocusVisible/useIsFocusVisible.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/useLazyRef/useLazyRef.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/useOnMount/useOnMount.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/usePreviousProps/usePreviousProps.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/project/node_modules/@mui/utils/esm/useSlotProps/useSlotProps.js");
;
import(/* webpackMode: "eager" */ "/root/project/node_modules/@mui/utils/esm/useTimeout/useTimeout.js");
;
import(/* webpackMode: "eager" */ "/root/project/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/root/project/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/root/project/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/root/project/node_modules/cookies-next/lib/client/context.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/root/project/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/project/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIntl"] */ "/root/project/node_modules/react-intl/index.js");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Accordion/AccordionDetails.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Accordion/AccordionSummary.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Card/Card.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Card/CardContent.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Dialog/DialogTitle.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/IconListItem/IconListItem.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Link/Link.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/LocaleContext/LocaleContext.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/NumberedListItem/NumberedListItem.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Rating/Rating.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Select/Listbox.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Select/Popup.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Select/Root.tsx");
;
import(/* webpackMode: "eager" */ "/root/project/packages/base-ui/components/Tooltip/Tooltip.tsx");
